var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form tab-content" },
    [
      _c(
        "v-expansion-panels",
        [
          _c(
            "v-expansion-panel",
            {
              staticStyle: { margin: "0 20px" },
              attrs: { id: "accessories-panel" }
            },
            [
              _c("v-expansion-panel-header", [
                _c("div", [_vm._v(_vm._s(_vm.$t("Included")))])
              ]),
              _vm._v(" "),
              _c(
                "v-expansion-panel-content",
                [
                  _c(
                    "v-card",
                    { staticStyle: { "box-shadow": "none" } },
                    [
                      _c("accessories-and-others-list", {
                        attrs: {
                          "accessories-selected":
                            _vm.accessoriesSelectedByMaterialId,
                          disabled: _vm.disabled,
                          "can-change-accessory": false
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-expansion-panel",
            { attrs: { id: "accessories-panel" } },
            [
              _c("v-expansion-panel-header", [
                _c("div", [_vm._v(_vm._s(_vm.$t("ToInclude")))])
              ]),
              _vm._v(" "),
              _c(
                "v-expansion-panel-content",
                [
                  _c(
                    "v-card",
                    { staticStyle: { "box-shadow": "none" } },
                    [
                      _vm.currentAction === "list"
                        ? _c("accessories-and-others-list", {
                            key: _vm.updated,
                            attrs: {
                              "accessories-selected": _vm.accessories,
                              disabled: _vm.disabled
                            },
                            on: {
                              addAccessory: function($event) {
                                return _vm.addAccessoriesForm($event)
                              },
                              "edit-item": function($event) {
                                return _vm.addAccessoriesForm("edit", $event)
                              },
                              "delete-item": function($event) {
                                return _vm.deleteRequestField($event)
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentAction !== "list" && !_vm.disabled
                        ? _c("accessories-and-others-form", {
                            attrs: {
                              "relation-family-id-select":
                                _vm.relationFamilyIdSelect,
                              "family-id": _vm.familyId,
                              "selected-fields": _vm.accessories,
                              "current-action": _vm.currentAction,
                              "original-item": _vm.requestFieldForm.data
                            },
                            on: {
                              add: _vm.addRequestField,
                              edit: _vm.editRequestField,
                              close: _vm.closeAddAccessoriesForm
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-647c0546", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-647c0546","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/AccessoriesAndOthers/AccessoriesAndOthersTab.vue
// module id = null
// module chunks = 